<template>
  <div class="example elevation-1">
      <p class="source">{{ value.text }}</p>
      <p class="target">{{ value.translatedText }}</p>
  </div>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style scoped>
  .source {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .example {
    border: 1px solid rgba(0,0,0,0.11);
    border-radius: 2px;
    padding: 8px;
    margin: 8px;
    max-width: 400px;
  }
  .target {
    margin-bottom: 0;
  }
</style>
